import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DeviceConfigurerServiceSharedModule } from '../../shared';
import {
    FeedService,
    FeedPopupService,
    FeedComponent,
    FeedDetailComponent,
    FeedDialogComponent,
    FeedPopupComponent,
    FeedDeletePopupComponent,
    FeedDeleteDialogComponent,
    feedRoute,
    feedPopupRoute,
} from './';

const ENTITY_STATES = [
    ...feedRoute,
    ...feedPopupRoute,
];

@NgModule({
    imports: [
        DeviceConfigurerServiceSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        FeedComponent,
        FeedDetailComponent,
        FeedDialogComponent,
        FeedDeleteDialogComponent,
        FeedPopupComponent,
        FeedDeletePopupComponent,
    ],
    entryComponents: [
        FeedComponent,
        FeedDialogComponent,
        FeedPopupComponent,
        FeedDeleteDialogComponent,
        FeedDeletePopupComponent,
    ],
    providers: [
        FeedService,
        FeedPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeviceConfigurerServiceFeedModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/feed/feed.module.ts